import React from 'react'
import formatMessage from 'format-message'

export const EditSVG = () => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 18 18">
      <title>{formatMessage('Edit icon')}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-933.000000, -534.000000)"
          fillRule="nonzero"
          fill="#384A58"
        >
          <path
            d="M936.896694,535.1463 C936.701984,534.951091 936.385916,534.951091 936.190253,535.146753 L934.146253,537.190753 C933.951516,537.385491 933.951516,537.702909 934.146151,537.897544 L935.513597,539.264196 L938.264491,536.513303 L936.896694,535.1463 Z M947.076593,545.3252 L938.9717,537.220307 L935.513803,540.678204 L935.160249,540.324856 L933.439147,538.604753 C932.853884,538.019491 932.853884,537.068909 933.439147,536.483647 L935.483147,534.439647 C936.069484,533.853309 937.019416,533.853309 937.604151,534.439544 L938.443397,535.278303 L938.443653,535.278047 L939.325202,536.159595 L939.67891,536.513097 L949.108684,545.943077 L950.150563,551.150063 L944.943593,550.108187 L936.456568,541.622174 L937.163632,540.915026 L944.325627,548.076166 L947.076593,545.3252 Z M947.7837,546.032307 L945.032776,548.78323 L945.436607,549.187013 L948.875637,549.875137 L948.187516,546.436123 L947.7837,546.032307 Z M938.326647,540.033753 L939.033753,539.326647 L945.217753,545.510647 L944.510647,546.217753 L938.326647,540.033753 Z"
            id="edit"
          />
        </g>
      </g>
    </svg>
  )
}

export const DeleteSVG = ({ color = null }) => {
  const deleteSVG = (
    <img
      alt={formatMessage('Delete icon')}
      src="/images/icons/delete-icon.svg"
      style={{
        width: '16px',
        height: '16px'
      }}
    />
  )
  const whiteSVG = (
    <img
      alt={formatMessage('Delete icon (white)')}
      src="/images/icons/delete-icon-white.svg"
      style={{
        width: '16px',
        height: '16px'
      }}
    />
  )
  return color ? whiteSVG : deleteSVG
}

export const CheckSVG = () => {
  return (
    <img
      alt={formatMessage('Check icon')}
      src="/images/icons/check.svg"
      style={{
        width: '16px',
        height: '16px'
      }}
    />
  )
}
